// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name=\"AutoComplateComponet\"] .autoCompleteList{\r\n    font-size: 12px;\r\n  }\r\n  [name=\"AutoComplateComponet\"] dd{\r\n    padding: 4px 4px 4px 4px;\r\n    margin: 3px 4px 4px 4px;\r\n    cursor: pointer;\r\n  }", ""]);
// Exports
module.exports = exports;
